import { render } from "./Index.vue?vue&type=template&id=78d66135"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/TransformationSegments/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78d66135"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78d66135', __exports__)) {
    api.reload('78d66135', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=78d66135", () => {
    api.rerender('78d66135', render)
  })

}


export default __exports__